export const HERO_OPTIONS = [
    { value: "Alchemist", label: "Alchemist", image: "src/img/heroes/alchemist.png" },
    { value: "Axe", label: "Axe", image: "src/img/heroes/axe.png" },
    { value: "Bristleback", label: "Bristleback", image: "src/img/heroes/bristleback.png" },
    { value: "Centaur Warrunner", label: "Centaur Warrunner", image: "src/img/heroes/centaur.png" },
    { value: "Chaos Knight", label: "Chaos Knight", image: "src/img/heroes/chaos_knight.png" },
    { value: "Dawnbreaker", label: "Dawnbreaker", image: "src/img/heroes/dawnbreaker.png" },
    { value: "Doom", label: "Doom", image: "src/img/heroes/doom_bringer.png" },
    { value: "Dragon Knight", label: "Dragon Knight", image: "src/img/heroes/dragon_knight.png" },
    { value: "Earth Spirit", label: "Earth Spirit", image: "src/img/heroes/earth_spirit.png" },
    { value: "Earthshaker", label: "Earthshaker", image: "src/img/heroes/earthshaker.png" },
    { value: "Elder Titan", label: "Elder Titan", image: "src/img/heroes/elder_titan.png" },
    { value: "Huskar", label: "Huskar", image: "src/img/heroes/huskar.png" },
    { value: "Kunkka", label: "Kunkka", image: "src/img/heroes/kunkka.png" },
    { value: "Legion Commander", label: "Legion Commander", image: "src/img/heroes/legion_commander.png" },
    { value: "Lifestealer", label: "Lifestealer", image: "src/img/heroes/life_stealer.png" },
    { value: "Mars", label: "Mars", image: "src/img/heroes/mars.png" },
    { value: "Night Stalker", label: "Night Stalker", image: "src/img/heroes/night_stalker.png" },
    { value: "Ogre Magi", label: "Ogre Magi", image: "src/img/heroes/ogre_magi.png" },
    { value: "Omniknight", label: "Omniknight", image: "src/img/heroes/omniknight.png" },
    { value: "Primal Beast", label: "Primal Beast", image: "src/img/heroes/primal_beast.png" },
    { value: "Pudge", label: "Pudge", image: "src/img/heroes/pudge.png" },
    { value: "Slardar", label: "Slardar", image: "src/img/heroes/slardar.png" },
    { value: "Spirit Breaker", label: "Spirit Breaker", image: "src/img/heroes/spirit_breaker.png" },
    { value: "Sven", label: "Sven", image: "src/img/heroes/sven.png" },
    { value: "Tidehunter", label: "Tidehunter", image: "src/img/heroes/tidehunter.png" },
    { value: "Tiny", label: "Tiny", image: "src/img/heroes/tiny.png" },
    { value: "Treant Protector", label: "Treant Protector", image: "src/img/heroes/treant.png" },
    { value: "Tusk", label: "Tusk", image: "src/img/heroes/tusk.png" },
    { value: "Underlord", label: "Underlord", image: "src/img/heroes/abyssal_underlord.png" },
    { value: "Undying", label: "Undying", image: "src/img/heroes/undying.png" },
    { value: "Wraith King", label: "Wraith King", image: "src/img/heroes/skeleton_king.png" },
    { value: "Anti-Mage", label: "Anti-Mage", image: "src/img/heroes/antimage.png" },
    { value: "Arc Warden", label: "Arc Warden", image: "src/img/heroes/arc_warden.png" },
    { value: "Bloodseeker", label: "Bloodseeker", image: "src/img/heroes/bloodseeker.png" },
    { value: "Bounty Hunter", label: "Bounty Hunter", image: "src/img/heroes/bounty_hunter.png" },
    { value: "Clinkz", label: "Clinkz", image: "src/img/heroes/clinkz.png" },
    { value: "Drow Ranger", label: "Drow Ranger", image: "src/img/heroes/drow_ranger.png" },
    { value: "Ember Spirit", label: "Ember Spirit", image: "src/img/heroes/ember_spirit.png" },
    { value: "Faceless Void", label: "Faceless Void", image: "src/img/heroes/faceless_void.png" },
    { value: "Gyrocopter", label: "Gyrocopter", image: "src/img/heroes/gyrocopter.png" },
    { value: "Hoodwink", label: "Hoodwink", image: "src/img/heroes/hoodwink.png" },
    { value: "Juggernaut", label: "Juggernaut", image: "src/img/heroes/juggernaut.png" },
    { value: "Kez", label: "Kez", image: "src/img/heroes/kez.png" },
    { value: "Luna", label: "Luna", image: "src/img/heroes/luna.png" },
    { value: "Medusa", label: "Medusa", image: "src/img/heroes/medusa.png" },
    { value: "Meepo", label: "Meepo", image: "src/img/heroes/meepo.png" },
    { value: "Monkey King", label: "Monkey King", image: "src/img/heroes/monkey_king.png" },
    { value: "Morphling", label: "Morphling", image: "src/img/heroes/morphling.png" },
    { value: "Naga Siren", label: "Naga Siren", image: "src/img/heroes/naga_siren.png" },
    { value: "Phantom Assassin", label: "Phantom Assassin", image: "src/img/heroes/phantom_assassin.png" },
    { value: "Phantom Lancer", label: "Phantom Lancer", image: "src/img/heroes/phantom_lancer.png" },
    { value: "Razor", label: "Razor", image: "src/img/heroes/razor.png" },
    { value: "Riki", label: "Riki", image: "src/img/heroes/riki.png" },
    { value: "Shadow Fiend", label: "Shadow Fiend", image: "src/img/heroes/nevermore.png" },
    { value: "Slark", label: "Slark", image: "src/img/heroes/slark.png" },
    { value: "Sniper", label: "Sniper", image: "src/img/heroes/sniper.png" },
    { value: "Spectre", label: "Spectre", image: "src/img/heroes/spectre.png" },
    { value: "Templar Assassin", label: "Templar Assassin", image: "src/img/heroes/templar_assassin.png" },
    { value: "Terrorblade", label: "Terrorblade", image: "src/img/heroes/terrorblade.png" },
    { value: "Troll Warlord", label: "Troll Warlord", image: "src/img/heroes/troll_warlord.png" },
    { value: "Ursa", label: "Ursa", image: "src/img/heroes/ursa.png" },
    { value: "Viper", label: "Viper", image: "src/img/heroes/viper.png" },
    { value: "Weaver", label: "Weaver", image: "src/img/heroes/weaver.png" },
    { value: "Ancient Apparition", label: "Ancient Apparition", image: "src/img/heroes/ancient_apparition.png" },
    { value: "Crystal Maiden", label: "Crystal Maiden", image: "src/img/heroes/crystal_maiden.png" },
    { value: "Death Prophet", label: "Death Prophet", image: "src/img/heroes/death_prophet.png" },
    { value: "Disruptor", label: "Disruptor", image: "src/img/heroes/disruptor.png" },
    { value: "Enchantress", label: "Enchantress", image: "src/img/heroes/enchantress.png" },
    { value: "Grimstroke", label: "Grimstroke", image: "src/img/heroes/grimstroke.png" },
    { value: "Jakiro", label: "Jakiro", image: "src/img/heroes/jakiro.png" },
    { value: "Keeper of the Light", label: "Keeper of the Light", image: "src/img/heroes/keeper_of_the_light.png" },
    { value: "Leshrac", label: "Leshrac", image: "src/img/heroes/leshrac.png" },
    { value: "Lich", label: "Lich", image: "src/img/heroes/lich.png" },
    { value: "Lina", label: "Lina", image: "src/img/heroes/lina.png" },
    { value: "Lion", label: "Lion", image: "src/img/heroes/lion.png" },
    { value: "Muerta", label: "Muerta", image: "src/img/heroes/muerta.png" },
    { value: "Nature's Prophet", label: "Nature's Prophet", image: "src/img/heroes/furion.png" },
    { value: "Necrophos", label: "Necrophos", image: "src/img/heroes/necrolyte.png" },
    { value: "Oracle", label: "Oracle", image: "src/img/heroes/oracle.png" },
    { value: "Outworld Destroyer", label: "Outworld Destroyer", image: "src/img/heroes/obsidian_destroyer.png" },
    { value: "Puck", label: "Puck", image: "src/img/heroes/puck.png" },
    { value: "Pugna", label: "Pugna", image: "src/img/heroes/pugna.png" },
    { value: "Queen of Pain", label: "Queen of Pain", image: "src/img/heroes/queenofpain.png" },
    { value: "Ringmaster", label: "Ringmaster", image: "src/img/heroes/ringmaster.png" },
    { value: "Rubick", label: "Rubick", image: "src/img/heroes/rubick.png" },
    { value: "Shadow Demon", label: "Shadow Demon", image: "src/img/heroes/shadow_demon.png" },
    { value: "Shadow Shaman", label: "Shadow Shaman", image: "src/img/heroes/shadow_shaman.png" },
    { value: "Silencer", label: "Silencer", image: "src/img/heroes/silencer.png" },
    { value: "Skywrath Mage", label: "Skywrath Mage", image: "src/img/heroes/skywrath_mage.png" },
    { value: "Storm Spirit", label: "Storm Spirit", image: "src/img/heroes/storm_spirit.png" },
    { value: "Tinker", label: "Tinker", image: "src/img/heroes/tinker.png" },
    { value: "Warlock", label: "Warlock", image: "src/img/heroes/warlock.png" },
    { value: "Witch Doctor", label: "Witch Doctor", image: "src/img/heroes/witch_doctor.png" },
    { value: "Zeus", label: "Zeus", image: "src/img/heroes/zuus.png" },
    { value: "Abaddon", label: "Abaddon", image: "src/img/heroes/abaddon.png" },
    { value: "Bane", label: "Bane", image: "src/img/heroes/bane.png" },
    { value: "Batrider", label: "Batrider", image: "src/img/heroes/batrider.png" },
    { value: "Beastmaster", label: "Beastmaster", image: "src/img/heroes/beastmaster.png" },
    { value: "Brewmaster", label: "Brewmaster", image: "src/img/heroes/brewmaster.png" },
    { value: "Broodmother", label: "Broodmother", image: "src/img/heroes/broodmother.png" },
    { value: "Chen", label: "Chen", image: "src/img/heroes/chen.png" },
    { value: "Clockwerk", label: "Clockwerk", image: "src/img/heroes/rattletrap.png" },
    { value: "Dark Seer", label: "Dark Seer", image: "src/img/heroes/dark_seer.png" },
    { value: "Dark Willow", label: "Dark Willow", image: "src/img/heroes/dark_willow.png" },
    { value: "Dazzle", label: "Dazzle", image: "src/img/heroes/dazzle.png" },
    { value: "Enigma", label: "Enigma", image: "src/img/heroes/enigma.png" },
    { value: "Invoker", label: "Invoker", image: "src/img/heroes/invoker.png" },
    { value: "Io", label: "Io", image: "src/img/heroes/wisp.png" },
    { value: "Lone Druid", label: "Lone Druid", image: "src/img/heroes/lone_druid.png" },
    { value: "Lycan", label: "Lycan", image: "src/img/heroes/lycan.png" },
    { value: "Magnus", label: "Magnus", image: "src/img/heroes/magnataur.png" },
    { value: "Marci", label: "Marci", image: "src/img/heroes/marci.png" },
    { value: "Mirana", label: "Mirana", image: "src/img/heroes/mirana.png" },
    { value: "Nyx Assassin", label: "Nyx Assassin", image: "src/img/heroes/nyx_assassin.png" },
    { value: "Pangolier", label: "Pangolier", image: "src/img/heroes/pangolier.png" },
    { value: "Phoenix", label: "Phoenix", image: "src/img/heroes/phoenix.png" },
    { value: "Sand King", label: "Sand King", image: "src/img/heroes/sand_king.png" },
    { value: "Snapfire", label: "Snapfire", image: "src/img/heroes/snapfire.png" },
    { value: "Techies", label: "Techies", image: "src/img/heroes/techies.png" },
    { value: "Timbersaw", label: "Timbersaw", image: "src/img/heroes/shredder.png" },
    { value: "Vengeful Spirit", label: "Vengeful Spirit", image: "src/img/heroes/vengefulspirit.png" },
    { value: "Venomancer", label: "Venomancer", image: "src/img/heroes/venomancer.png" },
    { value: "Visage", label: "Visage", image: "src/img/heroes/visage.png" },
    { value: "Void Spirit", label: "Void Spirit", image: "src/img/heroes/void_spirit.png" },
    { value: "Windranger", label: "Windranger", image: "src/img/heroes/windrunner.png" },
    { value: "Winter Wyvern", label: "Winter Wyvern", image: "src/img/heroes/winter_wyvern.png" },
];

export const HERO_COLUMNS = {
    "Alchemist": {
        name: "Alchemist",
        selector: row => row["Alchemist"],
        sortable: true,
        image: "src/img/heroes/alchemist.png"
    },
    "Axe": {
        name: "Axe",
        selector: row => row["Axe"],
        sortable: true,
        image: "src/img/heroes/axe.png"
    },
    "Bristleback": {
        name: "Bristleback",
        selector: row => row["Bristleback"],
        sortable: true,
        image: "src/img/heroes/bristleback.png"
    },
    "Centaur Warrunner": {
        name: "Centaur Warrunner",
        selector: row => row["Centaur Warrunner"],
        sortable: true,
        image: "src/img/heroes/centaur.png"
    },
    "Chaos Knight": {
        name: "Chaos Knight",
        selector: row => row["Chaos Knight"],
        sortable: true,
        image: "src/img/heroes/chaos_knight.png"
    },
    "Dawnbreaker": {
        name: "Dawnbreaker",
        selector: row => row["Dawnbreaker"],
        sortable: true,
        image: "src/img/heroes/dawnbreaker.png"
    },
    "Doom": {
        name: "Doom",
        selector: row => row["Doom"],
        sortable: true,
        image: "src/img/heroes/doom_bringer.png"
    },
    "Dragon Knight": {
        name: "Dragon Knight",
        selector: row => row["Dragon Knight"],
        sortable: true,
        image: "src/img/heroes/dragon_knight.png"
    },
    "Earth Spirit": {
        name: "Earth Spirit",
        selector: row => row["Earth Spirit"],
        sortable: true,
        image: "src/img/heroes/earth_spirit.png"
    },
    "Earthshaker": {
        name: "Earthshaker",
        selector: row => row["Earthshaker"],
        sortable: true,
        image: "src/img/heroes/earthshaker.png"
    },
    "Elder Titan": {
        name: "Elder Titan",
        selector: row => row["Elder Titan"],
        sortable: true,
        image: "src/img/heroes/elder_titan.png"
    },
    "Huskar": {
        name: "Huskar",
        selector: row => row["Huskar"],
        sortable: true,
        image: "src/img/heroes/huskar.png"
    },
    "Kunkka": {
        name: "Kunkka",
        selector: row => row["Kunkka"],
        sortable: true,
        image: "src/img/heroes/kunkka.png"
    },
    "Legion Commander": {
        name: "Legion Commander",
        selector: row => row["Legion Commander"],
        sortable: true,
        image: "src/img/heroes/legion_commander.png"
    },
    "Lifestealer": {
        name: "Lifestealer",
        selector: row => row["Lifestealer"],
        sortable: true,
        image: "src/img/heroes/life_stealer.png"
    },
    "Mars": {
        name: "Mars",
        selector: row => row["Mars"],
        sortable: true,
        image: "src/img/heroes/mars.png"
    },
    "Night Stalker": {
        name: "Night Stalker",
        selector: row => row["Night Stalker"],
        sortable: true,
        image: "src/img/heroes/night_stalker.png"
    },
    "Ogre Magi": {
        name: "Ogre Magi",
        selector: row => row["Ogre Magi"],
        sortable: true,
        image: "src/img/heroes/ogre_magi.png"
    },
    "Omniknight": {
        name: "Omniknight",
        selector: row => row["Omniknight"],
        sortable: true,
        image: "src/img/heroes/omniknight.png"
    },
    "Primal Beast": {
        name: "Primal Beast",
        selector: row => row["Primal Beast"],
        sortable: true,
        image: "src/img/heroes/primal_beast.png"
    },
    "Pudge": {
        name: "Pudge",
        selector: row => row["Pudge"],
        sortable: true,
        image: "src/img/heroes/pudge.png"
    },
    "Slardar": {
        name: "Slardar",
        selector: row => row["Slardar"],
        sortable: true,
        image: "src/img/heroes/slardar.png"
    },
    "Spirit Breaker": {
        name: "Spirit Breaker",
        selector: row => row["Spirit Breaker"],
        sortable: true,
        image: "src/img/heroes/spirit_breaker.png"
    },
    "Sven": {
        name: "Sven",
        selector: row => row["Sven"],
        sortable: true,
        image: "src/img/heroes/sven.png"
    },
    "Tidehunter": {
        name: "Tidehunter",
        selector: row => row["Tidehunter"],
        sortable: true,
        image: "src/img/heroes/tidehunter.png"
    },
    "Tiny": {
        name: "Tiny",
        selector: row => row["Tiny"],
        sortable: true,
        image: "src/img/heroes/tiny.png"
    },
    "Treant Protector": {
        name: "Treant Protector",
        selector: row => row["Treant Protector"],
        sortable: true,
        image: "src/img/heroes/treant.png"
    },
    "Tusk": {
        name: "Tusk",
        selector: row => row["Tusk"],
        sortable: true,
        image: "src/img/heroes/tusk.png"
    },
    "Underlord": {
        name: "Underlord",
        selector: row => row["Underlord"],
        sortable: true,
        image: "src/img/heroes/underlord.png"
    },
    "Undying": {
        name: "Undying",
        selector: row => row["Undying"],
        sortable: true,
        image: "src/img/heroes/undying.png"
    },
    "Wraith King": {
        name: "Wraith King",
        selector: row => row["Wraith King"],
        sortable: true,
        image: "src/img/heroes/skeleton_king.png"
    },
    "Anti-Mage": {
        name: "Anti-Mage",
        selector: row => row["Anti-Mage"],
        sortable: true,
        image: "src/img/heroes/anti-mage.png"
    },
    "Arc Warden": {
        name: "Arc Warden",
        selector: row => row["Arc Warden"],
        sortable: true,
        image: "src/img/heroes/arc_warden.png"
    },
    "Bloodseeker": {
        name: "Bloodseeker",
        selector: row => row["Bloodseeker"],
        sortable: true,
        image: "src/img/heroes/bloodseeker.png"
    },
    "Bounty Hunter": {
        name: "Bounty Hunter",
        selector: row => row["Bounty Hunter"],
        sortable: true,
        image: "src/img/heroes/bounty_hunter.png"
    },
    "Clinkz": {
        name: "Clinkz",
        selector: row => row["Clinkz"],
        sortable: true,
        image: "src/img/heroes/clinkz.png"
    },
    "Drow Ranger": {
        name: "Drow Ranger",
        selector: row => row["Drow Ranger"],
        sortable: true,
        image: "src/img/heroes/drow_ranger.png"
    },
    "Ember Spirit": {
        name: "Ember Spirit",
        selector: row => row["Ember Spirit"],
        sortable: true,
        image: "src/img/heroes/ember_spirit.png"
    },
    "Faceless Void": {
        name: "Faceless Void",
        selector: row => row["Faceless Void"],
        sortable: true,
        image: "src/img/heroes/faceless_void.png"
    },
    "Gyrocopter": {
        name: "Gyrocopter",
        selector: row => row["Gyrocopter"],
        sortable: true,
        image: "src/img/heroes/gyrocopter.png"
    },
    "Hoodwink": {
        name: "Hoodwink",
        selector: row => row["Hoodwink"],
        sortable: true,
        image: "src/img/heroes/hoodwink.png"
    },
    "Juggernaut": {
        name: "Juggernaut",
        selector: row => row["Juggernaut"],
        sortable: true,
        image: "src/img/heroes/juggernaut.png"
    },
    "Kez": {
        name: "Kez",
        selector: row => row["Kez"],
        sortable: true,
        image: "src/img/heroes/kez.png"
    },
    "Luna": {
        name: "Luna",
        selector: row => row["Luna"],
        sortable: true,
        image: "src/img/heroes/luna.png"
    },
    "Medusa": {
        name: "Medusa",
        selector: row => row["Medusa"],
        sortable: true,
        image: "src/img/heroes/medusa.png"
    },
    "Meepo": {
        name: "Meepo",
        selector: row => row["Meepo"],
        sortable: true,
        image: "src/img/heroes/meepo.png"
    },
    "Monkey King": {
        name: "Monkey King",
        selector: row => row["Monkey King"],
        sortable: true,
        image: "src/img/heroes/monkey_king.png"
    },
    "Morphling": {
        name: "Morphling",
        selector: row => row["Morphling"],
        sortable: true,
        image: "src/img/heroes/morphling.png"
    },
    "Naga Siren": {
        name: "Naga Siren",
        selector: row => row["Naga Siren"],
        sortable: true,
        image: "src/img/heroes/naga_siren.png"
    },
    "Phantom Assassin": {
        name: "Phantom Assassin",
        selector: row => row["Phantom Assassin"],
        sortable: true,
        image: "src/img/heroes/phantom_assassin.png"
    },
    "Phantom Lancer": {
        name: "Phantom Lancer",
        selector: row => row["Phantom Lancer"],
        sortable: true,
        image: "src/img/heroes/phantom_lancer.png"
    },
    "Razor": {
        name: "Razor",
        selector: row => row["Razor"],
        sortable: true,
        image: "src/img/heroes/razor.png"
    },
    "Riki": {
        name: "Riki",
        selector: row => row["Riki"],
        sortable: true,
        image: "src/img/heroes/riki.png"
    },
    "Shadow Fiend": {
        name: "Shadow Fiend",
        selector: row => row["Shadow Fiend"],
        sortable: true,
        image: "src/img/heroes/nevermore.png"
    },
    "Slark": {
        name: "Slark",
        selector: row => row["Slark"],
        sortable: true,
        image: "src/img/heroes/slark.png"
    },
    "Sniper": {
        name: "Sniper",
        selector: row => row["Sniper"],
        sortable: true,
        image: "src/img/heroes/sniper.png"
    },
    "Spectre": {
        name: "Spectre",
        selector: row => row["Spectre"],
        sortable: true,
        image: "src/img/heroes/spectre.png"
    },
    "Templar Assassin": {
        name: "Templar Assassin",
        selector: row => row["Templar Assassin"],
        sortable: true,
        image: "src/img/heroes/templar_assassin.png"
    },
    "Terrorblade": {
        name: "Terrorblade",
        selector: row => row["Terrorblade"],
        sortable: true,
        image: "src/img/heroes/terrorblade.png"
    },
    "Troll Warlord": {
        name: "Troll Warlord",
        selector: row => row["Troll Warlord"],
        sortable: true,
        image: "src/img/heroes/troll_warlord.png"
    },
    "Ursa": {
        name: "Ursa",
        selector: row => row["Ursa"],
        sortable: true,
        image: "src/img/heroes/ursa.png"
    },
    "Viper": {
        name: "Viper",
        selector: row => row["Viper"],
        sortable: true,
        image: "src/img/heroes/viper.png"
    },
    "Weaver": {
        name: "Weaver",
        selector: row => row["Weaver"],
        sortable: true,
        image: "src/img/heroes/weaver.png"
    },
    "Ancient Apparition": {
        name: "Ancient Apparition",
        selector: row => row["Ancient Apparition"],
        sortable: true,
        image: "src/img/heroes/ancient_apparition.png"
    },
    "Crystal Maiden": {
        name: "Crystal Maiden",
        selector: row => row["Crystal Maiden"],
        sortable: true,
        image: "src/img/heroes/crystal_maiden.png"
    },
    "Death Prophet": {
        name: "Death Prophet",
        selector: row => row["Death Prophet"],
        sortable: true,
        image: "src/img/heroes/death_prophet.png"
    },
    "Disruptor": {
        name: "Disruptor",
        selector: row => row["Disruptor"],
        sortable: true,
        image: "src/img/heroes/disruptor.png"
    },
    "Enchantress": {
        name: "Enchantress",
        selector: row => row["Enchantress"],
        sortable: true,
        image: "src/img/heroes/enchantress.png"
    },
    "Grimstroke": {
        name: "Grimstroke",
        selector: row => row["Grimstroke"],
        sortable: true,
        image: "src/img/heroes/grimstroke.png"
    },
    "Jakiro": {
        name: "Jakiro",
        selector: row => row["Jakiro"],
        sortable: true,
        image: "src/img/heroes/jakiro.png"
    },
    "Keeper of the Light": {
        name: "Keeper of the Light",
        selector: row => row["Keeper of the Light"],
        sortable: true,
        image: "src/img/heroes/keeper_of_the_light.png"
    },
    "Leshrac": {
        name: "Leshrac",
        selector: row => row["Leshrac"],
        sortable: true,
        image: "src/img/heroes/leshrac.png"
    },
    "Lich": {
        name: "Lich",
        selector: row => row["Lich"],
        sortable: true,
        image: "src/img/heroes/lich.png"
    },
    "Lina": {
        name: "Lina",
        selector: row => row["Lina"],
        sortable: true,
        image: "src/img/heroes/lina.png"
    },
    "Lion": {
        name: "Lion",
        selector: row => row["Lion"],
        sortable: true,
        image: "src/img/heroes/lion.png"
    },
    "Muerta": {
        name: "Muerta",
        selector: row => row["Muerta"],
        sortable: true,
        image: "src/img/heroes/muerta.png"
    },
    "Nature's Prophet": {
        name: "Nature's Prophet",
        selector: row => row["Nature's Prophet"],
        sortable: true,
        image: "src/img/heroes/furion.png"
    },
    "Necrophos": {
        name: "Necrophos",
        selector: row => row["Necrophos"],
        sortable: true,
        image: "src/img/heroes/necrolyte.png"
    },
    "Oracle": {
        name: "Oracle",
        selector: row => row["Oracle"],
        sortable: true,
        image: "src/img/heroes/oracle.png"
    },
    "Outworld Destroyer": {
        name: "Outworld Destroyer",
        selector: row => row["Outworld Destroyer"],
        sortable: true,
        image: "src/img/heroes/obsidian_destroyer.png"
    },
    "Puck": {
        name: "Puck",
        selector: row => row["Puck"],
        sortable: true,
        image: "src/img/heroes/puck.png"
    },
    "Pugna": {
        name: "Pugna",
        selector: row => row["Pugna"],
        sortable: true,
        image: "src/img/heroes/pugna.png"
    },
    "Queen of Pain": {
        name: "Queen of Pain",
        selector: row => row["Queen of Pain"],
        sortable: true,
        image: "src/img/heroes/queenofpain.png"
    },
    "Ringmaster": {
        name: "Ringmaster",
        selector: row => row["Ringmaster"],
        sortable: true,
        image: "src/img/heroes/ringmaster.png"
    },
    "Rubick": {
        name: "Rubick",
        selector: row => row["Rubick"],
        sortable: true,
        image: "src/img/heroes/rubick.png"
    },
    "Shadow Demon": {
        name: "Shadow Demon",
        selector: row => row["Shadow Demon"],
        sortable: true,
        image: "src/img/heroes/shadow_demon.png"
    },
    "Shadow Shaman": {
        name: "Shadow Shaman",
        selector: row => row["Shadow Shaman"],
        sortable: true,
        image: "src/img/heroes/shadow_shaman.png"
    },
    "Silencer": {
        name: "Silencer",
        selector: row => row["Silencer"],
        sortable: true,
        image: "src/img/heroes/silencer.png"
    },
    "Skywrath Mage": {
        name: "Skywrath Mage",
        selector: row => row["Skywrath Mage"],
        sortable: true,
        image: "src/img/heroes/skywrath_mage.png"
    },
    "Storm Spirit": {
        name: "Storm Spirit",
        selector: row => row["Storm Spirit"],
        sortable: true,
        image: "src/img/heroes/storm_spirit.png"
    },
    "Tinker": {
        name: "Tinker",
        selector: row => row["Tinker"],
        sortable: true,
        image: "src/img/heroes/tinker.png"
    },
    "Warlock": {
        name: "Warlock",
        selector: row => row["Warlock"],
        sortable: true,
        image: "src/img/heroes/warlock.png"
    },
    "Witch Doctor": {
        name: "Witch Doctor",
        selector: row => row["Witch Doctor"],
        sortable: true,
        image: "src/img/heroes/witch_doctor.png"
    },
    "Zeus": {
        name: "Zeus",
        selector: row => row["Zeus"],
        sortable: true,
        image: "src/img/heroes/zuus.png"
    },
    "Abaddon": {
        name: "Abaddon",
        selector: row => row["Abaddon"],
        sortable: true,
        image: "src/img/heroes/abaddon.png"
    },
    "Bane": {
        name: "Bane",
        selector: row => row["Bane"],
        sortable: true,
        image: "src/img/heroes/bane.png"
    },
    "Batrider": {
        name: "Batrider",
        selector: row => row["Batrider"],
        sortable: true,
        image: "src/img/heroes/batrider.png"
    },
    "Beastmaster": {
        name: "Beastmaster",
        selector: row => row["Beastmaster"],
        sortable: true,
        image: "src/img/heroes/beastmaster.png"
    },
    "Brewmaster": {
        name: "Brewmaster",
        selector: row => row["Brewmaster"],
        sortable: true,
        image: "src/img/heroes/brewmaster.png"
    },
    "Broodmother": {
        name: "Broodmother",
        selector: row => row["Broodmother"],
        sortable: true,
        image: "src/img/heroes/broodmother.png"
    },
    "Chen": {
        name: "Chen",
        selector: row => row["Chen"],
        sortable: true,
        image: "src/img/heroes/chen.png"
    },
    "Clockwerk": {
        name: "Clockwerk",
        selector: row => row["Clockwerk"],
        sortable: true,
        image: "src/img/heroes/rattletrap.png"
    },
    "Dark Seer": {
        name: "Dark Seer",
        selector: row => row["Dark Seer"],
        sortable: true,
        image: "src/img/heroes/dark_seer.png"
    },
    "Dark Willow": {
        name: "Dark Willow",
        selector: row => row["Dark Willow"],
        sortable: true,
        image: "src/img/heroes/dark_willow.png"
    },
    "Dazzle": {
        name: "Dazzle",
        selector: row => row["Dazzle"],
        sortable: true,
        image: "src/img/heroes/dazzle.png"
    },
    "Enigma": {
        name: "Enigma",
        selector: row => row["Enigma"],
        sortable: true,
        image: "src/img/heroes/enigma.png"
    },
    "Invoker": {
        name: "Invoker",
        selector: row => row["Invoker"],
        sortable: true,
        image: "src/img/heroes/invoker.png"
    },
    "Io": {
        name: "Io",
        selector: row => row["Io"],
        sortable: true,
        image: "src/img/heroes/wisp.png"
    },
    "Lone Druid": {
        name: "Lone Druid",
        selector: row => row["Lone Druid"],
        sortable: true,
        image: "src/img/heroes/lone_druid.png"
    },
    "Lycan": {
        name: "Lycan",
        selector: row => row["Lycan"],
        sortable: true,
        image: "src/img/heroes/lycan.png"
    },
    "Magnus": {
        name: "Magnus",
        selector: row => row["Magnus"],
        sortable: true,
        image: "src/img/heroes/magnataur.png"
    },
    "Marci": {
        name: "Marci",
        selector: row => row["Marci"],
        sortable: true,
        image: "src/img/heroes/marci.png"
    },
    "Mirana": {
        name: "Mirana",
        selector: row => row["Mirana"],
        sortable: true,
        image: "src/img/heroes/mirana.png"
    },
    "Nyx Assassin": {
        name: "Nyx Assassin",
        selector: row => row["Nyx Assassin"],
        sortable: true,
        image: "src/img/heroes/nyx_assassin.png"
    },
    "Pangolier": {
        name: "Pangolier",
        selector: row => row["Pangolier"],
        sortable: true,
        image: "src/img/heroes/pangolier.png"
    },
    "Phoenix": {
        name: "Phoenix",
        selector: row => row["Phoenix"],
        sortable: true,
        image: "src/img/heroes/phoenix.png"
    },
    "Sand King": {
        name: "Sand King",
        selector: row => row["Sand King"],
        sortable: true,
        image: "src/img/heroes/sand_king.png"
    },
    "Snapfire": {
        name: "Snapfire",
        selector: row => row["Snapfire"],
        sortable: true,
        image: "src/img/heroes/snapfire.png"
    },
    "Techies": {
        name: "Techies",
        selector: row => row["Techies"],
        sortable: true,
        image: "src/img/heroes/techies.png"
    },
    "Timbersaw": {
        name: "Timbersaw",
        selector: row => row["Timbersaw"],
        sortable: true,
        image: "src/img/heroes/shredder.png"
    },
    "Vengeful Spirit": {
        name: "Vengeful Spirit",
        selector: row => row["Vengeful Spirit"],
        sortable: true,
        image: "src/img/heroes/vengefulspirit.png"
    },
    "Venomancer": {
        name: "Venomancer",
        selector: row => row["Venomancer"],
        sortable: true,
        image: "src/img/heroes/venomancer.png"
    },
    "Visage": {
        name: "Visage",
        selector: row => row["Visage"],
        sortable: true,
        image: "src/img/heroes/visage.png"
    },
    "Void Spirit": {
        name: "Void Spirit",
        selector: row => row["Void Spirit"],
        sortable: true,
        image: "src/img/heroes/void_spirit.png"
    },
    "Windranger": {
        name: "Windranger",
        selector: row => row["Windranger"],
        sortable: true,
        image: "src/img/heroes/windrunner.png"
    },
    "Winter Wyvern": {
        name: "Winter Wyvern",
        selector: row => row["Winter Wyvern"],
        sortable: true,
        image: "src/img/heroes/winter_wyvern.png"
    },
}; 